import { Country } from '@40seas/entities/common';
import { addressProvider } from './addressProvider/addressProvider';

// These countries are pinned to the top of lists
const pinnedCountries = [Country.UNITED_STATES, Country.UNITED_KINGDOM, Country.GERMANY, Country.AUSTRALIA, Country.ITALY];

const countriesThatRequireZip = [
    Country.GERMANY,
    Country.NETHERLANDS,
    Country.UNITED_KINGDOM,
    Country.FRANCE,
    Country.BELGIUM,
    Country.ITALY,
    Country.SPAIN,
    Country.SLOVENIA,
    Country.CROATIA,
    Country.SWEDEN,
    Country.GREECE,
    Country.LITHUANIA,
    Country.DENMARK,
    Country.AUSTRIA,
    Country.CYPRUS,
    Country.ESTONIA,
    Country.FINLAND,
    Country.ICELAND,
    Country.LATVIA,
    Country.LUXEMBOURG,
    Country.MALTA,
    Country.NEW_ZEALAND,
    Country.PORTUGAL,
    Country.SAN_MARINO,
    Country.SLOVAKIA,
    Country.FINLAND,
    Country.SWEDEN,
    Country.AUSTRALIA,
    Country.IRELAND,
    Country.HUNGARY,
    Country.ROMANIA,
    Country.SWITZERLAND,
    Country.POLAND,
];

const countriesThatRequireAddressLine = [
    Country.ITALY,
    Country.PORTUGAL,
    Country.SLOVAKIA,
    Country.LATVIA,
    Country.UNITED_KINGDOM,
    Country.BELGIUM,
    Country.AUSTRALIA,
    Country.LITHUANIA,
    Country.NETHERLANDS,
    Country.AUSTRIA,
    Country.DENMARK,
    Country.GERMANY,
    Country.NEW_ZEALAND,
    Country.SWEDEN,
    Country.MALTA,
    Country.ICELAND,
    Country.CYPRUS,
    Country.ESTONIA,
    Country.SPAIN,
    Country.SAN_MARINO,
    Country.LUXEMBOURG,
    Country.SLOVENIA,
    Country.GREECE,
    Country.FINLAND,
    Country.FRANCE,
    Country.CROATIA,
    Country.IRELAND,
    Country.HUNGARY,
    Country.SWITZERLAND,
];

const countriesThatRequireState = [Country.UNITED_STATES];

const countriesThatRequireCity = [
    Country.UNITED_KINGDOM,
    Country.FRANCE,
    Country.NEW_ZEALAND,
    Country.NORWAY,
    Country.FINLAND,
    Country.AUSTRALIA,
    Country.GERMANY,
];

const getCountryTranslateKey = (key: Country) => (Object.values(Country).includes(key) ? `enums.country.${key}` : '');

function getCountryChoices({
    supportedCountries,
    labelFn = addressProvider.getCountryDisplayNameByLocale('en').of,
    pinCountries,
}: {
    supportedCountries?: Country[];
    labelFn?: (country: Country) => string;
    pinCountries?: boolean;
}) {
    const countries = supportedCountries?.length ? supportedCountries : Object.values(Country);

    const countryChoices = countries.map((code) => ({ label: labelFn(code), id: code })).sort((a, b) => a.label.localeCompare(b.label));

    if (!pinCountries) {
        return countryChoices;
    }

    const pinnedChoices = pinnedCountries
        .filter((code) => countries.includes(code))
        // In the following line, we add a zero width space as a fix for MUI bug with options having the same label
        .map((code) => ({ label: labelFn(code) + '\u200B', id: code }));

    return [...pinnedChoices, ...countryChoices];
}

const isZipRequiredInCountry = (country: Country): boolean => {
    return countriesThatRequireZip.includes(country);
};

const isAddressLineRequiredInCountry = (country: Country): boolean => {
    return countriesThatRequireAddressLine.includes(country);
};

const isStateRequiredInCountry = (country: Country): boolean => {
    return countriesThatRequireState.includes(country);
};

const isCityRequiredInCountry = (country: Country): boolean => {
    return countriesThatRequireCity.includes(country);
};

export const countryChoicesProvider = {
    getCountryChoices,
    getDefaultCountry: () => Country.UNITED_STATES,
    getCountryTranslateKey,
    isZipRequiredInCountry,
    isAddressLineRequiredInCountry,
    isStateRequiredInCountry,
    isCityRequiredInCountry,
};
